export enum NotificationsKeys {
  FAIL_SAVE = 'FAIL_SAVE',
  FAIL_UPDATE = 'FAIL_UPDATE',
  FAIL_DELETE = 'FAIL_DELETE',
}

export const Notifications: Record<NotificationsKeys, string> = {
  [NotificationsKeys.FAIL_SAVE]: 'Возникла ошибка при сохранении данных',
  [NotificationsKeys.FAIL_UPDATE]: 'Возникла ошибка при изменении данных',
  [NotificationsKeys.FAIL_DELETE]: 'Возникла ошибка при удалении данных',
}
